'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _HighlightTitleForPackage = require('./HighlightTitleForPackage.scss');var _HighlightTitleForPackage2 = _interopRequireDefault(_HighlightTitleForPackage);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var HighlightTitleForPackage = function HighlightTitleForPackage(props) {var
  highlight = props.highlight,isMobile = props.isMobile,translate = props.translate,locale = props.locale,inIframe = props.inIframe;
  var highlightTitle = highlight > 1 ? 'highlights' : 'highlight';
  var title = isMobile || inIframe ? 'forFree' : highlightTitle;

  var highlights =
  _react2.default.createElement('span', {
      className: (0, _classnames2.default)(
      _HighlightTitleForPackage2.default.centered,
      !inIframe && locale === 'ru' ? _HighlightTitleForPackage2.default.notBold : _HighlightTitleForPackage2.default.boldText,
      !inIframe && _HighlightTitleForPackage2.default.indented) },


    (isMobile || inIframe) && _react2.default.createElement('span', { className: _HighlightTitleForPackage2.default.quantity }, '\xA0', highlight + ' \xD7'), '\xA0',
    _react2.default.createElement('i', { className: 'icon-promoted-active' }), '\xA0',
    !isMobile && !inIframe && _react2.default.createElement('span', { className: _HighlightTitleForPackage2.default.quantity }, '\xD7 ' + highlight, '\xA0'),
    _react2.default.createElement('span', null, translate(title)));



  return isMobile || inIframe ? highlights : _react2.default.createElement('span', { className: _HighlightTitleForPackage2.default.centered }, '\xA0+\xA0', highlights);
};

HighlightTitleForPackage.propTypes = {
  isMobile: _propTypes2.default.bool,
  highlight: _propTypes2.default.number,
  translate: _propTypes2.default.func,
  locale: _propTypes2.default.string,
  inIframe: _propTypes2.default.bool };


HighlightTitleForPackage.defaultProps = {
  inIframe: false };exports.default =


HighlightTitleForPackage;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/HighlightTitleForPackage/HighlightTitleForPackage.js
// module id = 2691
// module chunks = 0